/**
 * Infer the RxType from the full OCR extraction text (e.g. markdown).
 *
 * Returns the RxType id string or null if no match.
 */
export function inferRxType(text: string): string | null {
  if (!text) return null;

  const lower = text.toLowerCase();

  if (lower.includes("heilmittelverordnung 13")) {
    return "Kasse";
  }

  if (lower.includes("zahnärztliche heilmittelverordnung")) {
    return "Zahnarzt";
  }

  return null;
}
